module.exports = __webpack_public_path__ + "static/img/10015 (3).7f47fc2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10015 (3).webp
// module id = +MpO
// module chunks = 14